import React from 'react';
import PropTypes from 'prop-types';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

/**
 * TopPagesTable - Atomic component for displaying top visited pages
 */
const TopPagesTable = ({ data, emptyMessage = 'No data available' }) => {
  if (!data || data.length === 0) {
    return (
      <Card>
        <CardHeader>
          <CardTitle className="text-lg font-bold text-[#1e3a8a]">
            Top Visited Pages
          </CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-center text-slate-500 py-8">{emptyMessage}</p>
        </CardContent>
      </Card>
    );
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-lg font-bold text-[#1e3a8a]">
          Top Visited Pages
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead>
              <tr className="border-b border-slate-200">
                <th className="text-left py-3 px-4 font-semibold text-slate-600">Page</th>
                <th className="text-right py-3 px-4 font-semibold text-slate-600">Views</th>
                <th className="text-right py-3 px-4 font-semibold text-slate-600">Unique Visitors</th>
              </tr>
            </thead>
            <tbody>
              {data.map((page, index) => (
                <tr key={index} className="border-b border-slate-100 hover:bg-slate-50 transition-colors">
                  <td className="py-3 px-4">
                    <span className="text-[#1e3a8a] font-medium">{page.page_url || '/'}</span>
                  </td>
                  <td className="py-3 px-4 text-right">
                    <span className="bg-blue-100 text-blue-800 px-2 py-1 rounded-full text-sm font-medium">
                      {page.views}
                    </span>
                  </td>
                  <td className="py-3 px-4 text-right">
                    <span className="bg-green-100 text-green-800 px-2 py-1 rounded-full text-sm font-medium">
                      {page.unique_visitors}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </CardContent>
    </Card>
  );
};

TopPagesTable.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape({
    page_url: PropTypes.string,
    views: PropTypes.number.isRequired,
    unique_visitors: PropTypes.number.isRequired
  })),
  emptyMessage: PropTypes.string
};

TopPagesTable.defaultProps = {
  data: [],
  emptyMessage: 'No page view data yet'
};

export default TopPagesTable;
